
import JessieOLP from './olp-jessie-min'

let OLP = JessieOLP.OLP;
global.OLP = OLP;

(function () {

    OLP.redirect = function (url) {
        window.location = url;
    };

    OLP.isObject = function (obj) {
        var type = typeof obj;
        return type === 'function' || type === 'object' && !!obj;
    };

    OLP.obj = function (id) {
        return document.getElementById(id);
    };

    OLP.confirm_message = function (message, url) {
        if (confirm(message)) {
            OLP.redirect(url);
        }
    };

    OLP.getSelectValue = function (el) {
        return el.options[el.selectedIndex].value;
    };

    OLP.changeElementPresence = function (el, display) {
        el.style.display = display ? '' : 'none';
    };

    OLP.changeAll = function (frm, value) {
        for (var i = 0, len = frm.elements.length; i < len; ++i) {
            var element = frm.elements[i];
            if (element.type == 'checkbox') {
                element.checked = !!value;
            }
        }
    };
    
    OLP.trim = function(str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
    };
    
    OLP.trimToLower = function(str) {
        return OLP.trim(str.toLocaleLowerCase ? str.toLocaleLowerCase() : str.toLowerCase()); 
    };

    OLP.getRadioValue = function (name) {
        var radios = document.getElementsByName(name);
        for (var i = 0, length = radios.length; i < length; i++) {
            if (radios[i].checked) {
                return radios[i].value;
            }
        }
        return undefined;
    };

    var docReadyQueue = [];
    var readyListenerFired = false;

    OLP.readyListener = function () {
        if (!readyListenerFired) {
            readyListenerFired = true;
            var len = docReadyQueue.length, x = 0;
            for(;x < len; ++x) {
                docReadyQueue[x]();
            }
        }
    };

    if (OLP.deferUntilReady) {

        OLP.deferUntilReady(OLP.readyListener);
    }

    OLP.docReady = function (fn) {
        docReadyQueue.push(fn);
    };
    
    OLP.functionReady = function(funcName, fn, missingFn) {
        if(OLP[funcName]) {
            OLP.docReady(fn);
        } else if(missingFn) {
            missingFn();
        }
    };
    
    OLP.getElementsByClassName = (function() {
        if(OLP.isHostMethod(document, "getElementsByClassName")) {
            return function (el, className) {
                return OLP.toArray(el.getElementsByClassName(className));
            };
        } else if (OLP.getDescendantsByClassName) {
            return function(el, className) {
                return OLP.getDescendantsByClassName(el, className);
            };
        }
        
        return null;
    })();
    
    if (OLP.isHostMethod(window, "getSelection") && OLP.isHostMethod(document, "createRange")) {
        OLP.selectLink = function (el) {
            var range, selection;
            selection = window.getSelection();
            range = document.createRange();
            range.selectNodeContents(el);
            selection.removeAllRanges();
            selection.addRange(range);
        };
    } else if (OLP.isHostMethod(document, "selection") && OLP.isHostMethod(document, "createTextRange")) {
        OLP.selectLink = function (el) {
            var range = document.body.createTextRange();
            range.moveToElementText(el);
            range.select();
        }
    }

    if(OLP.getViewportSize) {
        OLP.getViewportWidth = function () {
            return OLP.getViewportSize()[0];
        }
    }

    if(OLP.getAncestorByClassName && OLP.getDescendantsByClassName && OLP.addClass) {
        OLP.toolbox = (function () {
            var toolbox;

            function changeOptions(e) {
                if (OLP.hasClass(toolbox, "toolbox-container-active")) {
                    OLP.removeClass(toolbox, "toolbox-container-active");
                } else {
                    OLP.addClass(toolbox, "toolbox-container-active");
                }
            }

            function enableDateButton() {
                var button = OLP.obj("date-range-button");
                if (!button) return;

                var span = OLP.getAncestorByTagName(button, "span");
                var dateRangeContainer = OLP.obj("date-range-container");
                OLP.changeElementPresence(dateRangeContainer, OLP.hasClass(span, "switch-label-on"));

                button.onclick = function () {
                    var parent = OLP.getAncestorByClassName(this, "toolbox-report-types-container");
                    OLP.forEach(OLP.getDescendantsByClassName(parent, "switch-label-on"), function (el) {
                        OLP.removeClass(el, "switch-label-on");
                    });

                    OLP.addClass(span, "switch-label-on");
                    OLP.changeElementPresence(dateRangeContainer, true);

                    return false;
                };

                button = null;
            }

            return function (toolboxId) {
                toolbox = OLP.getElement(toolboxId);
                OLP.addClass(toolbox, "toolbox-container-init");

                var toolboxHeader = OLP.getDescendantsByClassName(toolbox, "toolbox-header-container")[0];
                toolboxHeader.onclick = changeOptions;

                var toolboxContainer = toolbox.parentNode;
                toolboxContainer.style.minHeight = OLP.getOuterSize(toolboxContainer)[0] + "px";

                enableDateButton();
            };
        })();
    }
    
    if(OLP.toolbox) {
        OLP.dateToolbox = (function () {
            var minDate;
            var maxDate;

            function adjustDates(dateOption) {
                var value = OLP.getSelectValue(dateOption);
                var isCustom = value == "custom";

                if (isCustom) {
                    return;
                }
                var now = new Date();
                var startDate = new Date();
                var endDate = new Date();

                switch (value) {
                    case "all":
                        startDate = minDate;
                        endDate = maxDate;
                        break;
                    case "today":
                        startDate.setDate(endDate.getDate());
                        endDate = startDate;
                        break;
                    case "yesterday":
                        startDate.setDate(now.getDate() - 1);
                        endDate = startDate;
                        break;
                    case "last_7_days":
                        startDate.setDate(endDate.getDate() - 7);
                        break;
                    case "last_30_days":
                        startDate.setDate(endDate.getDate() - 30);
                        break;
                    default:
                        startDate = new Date(value * 1000);
                        startDate.setDate(1);
                        endDate = new Date(value * 1000);
                        endDate.setDate(1);
                        endDate.setMonth(endDate.getMonth() + 1);
                        endDate.setDate(0);
                        break;
                }


                OLP.getElement("start_date").value = startDate.format("M j, Y");
                OLP.getElement("end_date").value = endDate.format("M j, Y");
            }

            function flipToCustom(e) {
                var dateOption = this.form.elements["date_option"];
                dateOption.selectedIndex = dateOption.options.length - 1;
            }

            return function (toolboxId, minDateTs, maxDateTs) {


                minDate = new Date(minDateTs);
                maxDate = new Date(maxDateTs);

                if (OLP.getElement("start_date")) {
                    OLP.getElement("start_date").onkeyup = flipToCustom;
                    OLP.getElement("end_date").onkeyup = flipToCustom;
                }


                var dateOption = OLP.getElement("date_option");
                if (dateOption) {
                    dateOption.style.display = "inline";
                    dateOption.onclick = dateOption.onchange = dateOption.onblur = function (e) {
                        adjustDates(this);
                    };
                    adjustDates(dateOption);
                }
                dateOption = null;

                OLP.toolbox(toolboxId);
            };
        })()
    }
    
    if(OLP.getDescendantsByTagName && OLP.query && OLP.getViewportWidth) {
        OLP.statBubble = (function () {
            function showBubble(el) {

                var statInfoBubble = OLP.getElement("stat-info-bubble");
                statInfoBubble.parentNode.removeChild(statInfoBubble);
                el.appendChild(statInfoBubble);

                statInfoBubble.innerHTML = el.title.replace(",", "<br>");
                statInfoBubble.style.display = "block";
            }

            return function () {
                OLP.getElement("stat-info-bubble").onclick = function (event) {
                    this.style.display = 'none';

                    event = event || window.event;
                    OLP.cancelPropagation(event);
                };


                OLP.forEach(OLP.query("td.name"), function (el) {
                    var divs = OLP.getDescendantsByTagName(el, "div");

                    if (divs.length > 0 && divs[0].title.length > 0) {
                        divs[0].onclick = function () {
                            showBubble(this);
                        }

                    }
                    divs = null;
                });
            };
        })();
    }
    
    if(OLP.getViewportWidth && OLP.getElementsByClassName) {
        OLP.initHelpToggle = function () {
            if (OLP.getViewportWidth() >= 700) {
                return;
            }
            var helpButtons;

            helpButtons = OLP.getElementsByClassName(document, "help-button");
            if (helpButtons.length == 0) {
                return;
            }
            OLP.forEach(helpButtons, function(helpButton) {
                var helpButtonContent = OLP.getElementsByClassName(helpButton, "help-button-content")[0];

                var helpTexts = OLP.getElementsByClassName(helpButton.parentNode, "help-text");
                if(helpTexts.length != 1) {
                    return;
                }
                
                var helpText = helpTexts[0];

                helpText.parentNode.removeChild(helpText);
                helpButtonContent.appendChild(helpText);
                
                helpButton.style.display = 'block';
                helpButton.onclick = function (e) {
                    if (OLP.hasClass(helpText, "help-text-active")) {
                        OLP.removeClass(helpText, "help-text-active");
                    } else {
                        OLP.addClass(helpText, "help-text-active");
                    }
                };

                OLP.addClass(helpText, "help-text-init");
                helpButton = null;
            });
        };
    }

    (function() {
        var currentTarget = null;

        OLP.hideHelp = function () {
            var overlay = OLP.obj("overlay");
            var helpContent = OLP.obj("help-modal-content");

            overlay.style.display = 'none';
            helpContent.style.display = 'none';
            if (currentTarget !== null) {
                OLP.removeClass(currentTarget, "help-modal-target");
                currentTarget = null;
            }
        };
        OLP.showHelp = function (target) {
            var overlay = OLP.obj("overlay");
            var helpContent = OLP.obj("help-modal-content");

            helpContent.onclick = overlay.onclick = function () {
                OLP.hideHelp();
            };

            if (target !== undefined) {
                OLP.addClass(target, "help-modal-target");
                currentTarget = target;
            } 
            overlay.style.display = 'block';
            helpContent.style.display = 'block';
            overlay = null;
            helpContent = null;
        };
    })();



    if(OLP.getEventTarget && OLP.getDescendantsByTagName && OLP.getAncestorByTagName) {
        OLP.clickableTable = function (el) {

            el.onclick = function (clickEvent) {

                clickEvent = clickEvent || window.event;

                var target = OLP.getEventTarget(clickEvent);
                if (target != null && target.tagName != "A" && target.tagName != "TH" && target.tagName != "CAPTION") {
                    var aTags = OLP.getDescendantsByTagName(target, "a");
                    if (aTags.length == 0) {
                        aTags = OLP.getDescendantsByTagName(target.parentNode, "a");
                    }

                    if (aTags.length > 0) {
                        var aTag = aTags[0];

                        if (aTag != null) {
                            if (typeof(aTag.onclick) != "function") {
                                location.href = aTag.href;
                            }
                        }
                        return false;
                    }
                }

                return true;
            };

            OLP.addClass(el, "table-row-clickable");
            el = null;


        };

        OLP.clickableFormSubmitRow = function (el) {
            el.onclick = function (clickEvent) {
                clickEvent = clickEvent || window.event;
                var target = OLP.getEventTarget(clickEvent);
                if (!target) return true;

                var tagName = target.tagName.toLowerCase();

                if (tagName == "input" || tagName == "table") return true;

                var row = OLP.getAncestorByTagName(target, "tr");
                if (!row) return true;

                var inputs = OLP.getDescendantsByTagName(row, "input");
                var submittedForm = false;
                OLP.forEach(inputs, function (input) {
                    if (input.type.toLowerCase() == "submit") {
                        var altAction = OLP.obj("alt_action");
                        if(altAction != null) {
                            
                            altAction.name = input.name;
                            altAction.value = input.value;
                            input.form.submit();
                            submittedForm = true;
                        }
                    }
                });

                return !submittedForm;
            };
            OLP.addClass(el, "table-row-clickable");
            el = null;
        };
    }

    if(OLP.getDescendantsByClassName && OLP.cancelPropagation && OLP.appendHtml) {
        OLP.searchFilter = function (tableId, searchIconId) {

            var table = OLP.obj(tableId);
            var searchIcon = OLP.obj(searchIconId);
            var searchInput = null;

            function filterTable(val) {
                val = OLP.trimToLower(val.toLocaleLowerCase());
                var rows = OLP.getDescendantsByTagName(table, "tr");

                for (var i = rows.length; i--;) {
                    var row = rows[i];
                    var teamNames = OLP.getDescendantsByClassName(row, "team-name");
                    if (teamNames.length != 1) {
                        continue;
                    }
                    var teamName = teamNames[0].innerText || teamNames[0].textContent;

                    var showRow = OLP.trimToLower(teamName).indexOf(val) !== -1;
                    OLP.changeElementPresence(row.parentNode, showRow);
                }

            }

            function showSearch(searchIcon) {
                if (!searchInput) {
                    var html = "<div class='search-container'><input type='text' name='search' placeholder='Search For Teams' id='search-value'></div>";
                    OLP.appendHtml(searchIcon.parentNode, html);
                    searchInput = OLP.obj("search-value");
                    searchInput.onkeyup = function () {
                        filterTable(this.value);
                    };
                }
            }

            searchIcon.onclick = function (e) {
                showSearch(this);
                OLP.cancelPropagation(e || window.event);
            };

            OLP.addClass(searchIcon, "search-icon-active");

        };
    }


    OLP.copyToClipboard = async function(text, statusEl) {

        if(!OLP.shareText(text)) {
            await navigator.clipboard.writeText(text);
            OLP.obj(statusEl).innerHTML = "Copied!";
            setTimeout(function () {
                OLP.obj(statusEl).innerHTML = "";
            }, 2000);
        }
    }



})();
